export default __webpack_public_path__ + "static/logo-white-0e285852d2bbaade50b3a124845ae531.svg";